import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chakra-ui/react'
import Logo from '../../../components/ui/Logo'
import MenuSectionContainer from './MenuSectionContainer'
import { MenuSearch } from './MenuSearch'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'

export const ReportMenu = observer(props => {
  const navigate = useNavigate()
  const {
    reportStore: { loadingReport },
  } = rootStore

  return (
    <Flex
      bg="blue.700"
      direction="column"
      w="auto"
      h="100vh"
      p={'42px 32px 0 32px'}
      overflow="auto"
      position={'relative'}
      alignItems={'center'}
      {...props}>
      <Box
        mb="32px"
        _hover={{
          cursor: 'pointer',
        }}
        display="flex"
        justifyContent="center"
        onClick={() => navigate('/')}>
        <Logo
          width={110}
          height="auto"
          objectFit="contain"
        />
      </Box>
      <MenuSearch />
      <Box
        mt="12px"
        width="100%">
        <MenuSectionContainer />
      </Box>
    </Flex>
  )
})

ReportMenu.propTypes = {
  reports: PropTypes.array,
}
